import React from 'react';
import classnames from 'classnames';

import CauzeSpinner from '../CauzeSpinner/CauzeSpinner';

const Button = ({
  children,
  onClick = () => {},
  _sm,
  outline,
  white,
  purple,
  href,
  className,
  disabled,
  isSubmitting,
  style,
  type = 'button',
  spanClassName = '',
}) =>
  href ? (
    <a
      className={classnames(
        'button',
        {
          'is-primary': !white && !purple,
          'is-secondary': purple,
          'is-outlined': outline,
        },
        className,
      )}
      onClick={onClick}
      href={href}
    >
      <span className={spanClassName}>{children}</span>
    </a>
  ) : (
    <button
      style={style}
      className={classnames(
        'button',
        {
          'is-primary': !white && !purple,
          'is-secondary': purple,
          'is-outlined': outline,
        },
        className,
      )}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {isSubmitting && (
        <CauzeSpinner
          style={{
            margin: 'auto',
            position: 'absolute',
            width: '20px',
            height: '20px',
          }}
        />
      )}
      <span
        className={classnames({ 'is-submitting': isSubmitting }, spanClassName)}
      >
        {children}
      </span>
    </button>
  );

export default Button;
